import { useGarden } from '../../garden/GardenContext';
import ActionLog from '../ActionLog/ActionLog';
import BulkActionsPanel from './BulkActionsPanel';
import './DetailPanel.css';

function DetailPanel() {
  const { elements, selectedElementIds, selectElement, renameElement, deleteElement } = useGarden();

  if (selectedElementIds.length === 0) {
    return (
      <aside className="detail-panel detail-panel--empty">
        <p>
          Select an element on the canvas to see its details. Ctrl-click to select more than one.
        </p>
      </aside>
    );
  }

  if (selectedElementIds.length > 1) {
    const selected = elements.filter((el) => selectedElementIds.includes(el.id));
    return <BulkActionsPanel elements={selected} />;
  }

  const element = elements.find((el) => el.id === selectedElementIds[0]);
  if (!element) {
    return (
      <aside className="detail-panel detail-panel--empty">
        <p>
          Select an element on the canvas to see its details. Ctrl-click to select more than one.
        </p>
      </aside>
    );
  }

  return (
    <aside className="detail-panel">
      <button type="button" className="detail-panel__close" onClick={() => selectElement(null)}>
        Close
      </button>
      <label className="detail-panel__name-label">
        Name
        <input
          type="text"
          value={element.name}
          onChange={(e) => renameElement(element.id, e.target.value)}
          className="detail-panel__name-input"
        />
      </label>
      <button
        type="button"
        className="detail-panel__delete"
        onClick={() => deleteElement(element.id)}
      >
        Delete element
      </button>
      <ActionLog elementId={element.id} entries={element.actions} />
    </aside>
  );
}

export default DetailPanel;
